var map = {
	"./arr_next.svg": "/sC/",
	"./arr_prev.svg": "+fuI",
	"./arrow.svg": "MBUd",
	"./arrow_2.svg": "06PQ",
	"./calculator.svg": "zxfD",
	"./check.svg": "XrWa",
	"./chicken.svg": "hbg5",
	"./clock.svg": "a+fQ",
	"./clock_2.svg": "rwaV",
	"./close_edit.svg": "jpKV",
	"./coins.svg": "7zai",
	"./cross.svg": "xf14",
	"./edit.svg": "VvlZ",
	"./find_location_pin.svg": "fcMa",
	"./info.svg": "n8kC",
	"./location.svg": "2yjo",
	"./location_filled.svg": "sHSi",
	"./locaton_out.svg": "HTvj",
	"./marker.svg": "4QCf",
	"./message.svg": "KJSq",
	"./phone.svg": "q8hP",
	"./phone_2.svg": "wCuJ",
	"./phone_3.svg": "/LtD",
	"./phone_round.svg": "g/cz",
	"./pin.svg": "Nivw",
	"./pointer.svg": "3cwx",
	"./smile.svg": "2BXY",
	"./tick.svg": "fCY4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "O01h";